import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { TrainingPlanComponent } from '../training-plan/training-plan.component';
import { TmsMastersDataService } from '../../../../data-services/tms-masters-data.service';
import { catchError, of } from 'rxjs';
import { AlertsService } from '../../../../ui-framework/global-services/utility-service/alerts-service';
@Component({
  selector: 'app-trainer-history',
  imports: [//MatDialogActions, 
    MatDialogContent,MatDialogClose,],
  templateUrl: './trainer-history.component.html',
  styleUrl: './trainer-history.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainerHistoryComponent {
trainerHistory = signal<any[]>([]);
  constructor(
    private tmsApiService: TmsMastersDataService,
    private alertsService: AlertsService,
  ) {
     
  }
data = inject<TrainerHistoryDialogData>(MAT_DIALOG_DATA);

  ngOnInit() {
    if(this.data.trainerId && this.data.startDate && this.data.endDate){
      this.getTrainerHistory(this.data.trainerId, this.data.startDate.toISOString().split('T')[0], this.data.endDate.toISOString().split('T')[0]);
  }

}
  getTrainerHistory(trainerId: string , startDate: string , endDate: string ) {
    this.tmsApiService.getTrainerAlocationByDuration(trainerId, startDate, endDate).pipe(
      catchError((error: HttpErrorResponse) => {
        this.trainerHistory.set([]);

        if (error.status !== 404) {
          this.alertsService.showErrorAlert('Failed to load trainer history.').subscribe();
        }

        return of([]);
      })
    ).subscribe(
       (response) => {
        this.trainerHistory.set(response);
      }

    );
  }
}

export interface TrainerHistoryDialogData {
  trainerId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
}
